import './style.scss';

import React from 'react';
import AuthPageContainer from './container';
import ForgotPasswordForm from 'components/login/forgot';
import Text from 'components/ui/text';
import View from 'components/ui/view';

class ForgotPasswordPage extends React.Component {
  render() {
    return (
      <AuthPageContainer
        renderNav={() => (
          <a
            href="/signup"
            className="btn-link btn-small signup-page__header-btn"
          >
            Sign Up
          </a>
        )}
        renderFooter={() => (
          <div className="signup-page__form-footer">
            <small>
              Don{"'"}t have an account?{' '}
              <a href="/signup" className="link-text">
                Sign up
              </a>.
            </small>
          </div>
        )}
      >
        <View padding="sm">
          <Text display tag="h1" size="xxl" weight="med" margin="none">
            Forgot Password
          </Text>
        </View>
        <View padding="sm">
          <ForgotPasswordForm />
        </View>
      </AuthPageContainer>
    );
  }
}

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./shared/components/authPages/forgot.js